/**
 * Module dependencies.
 */

import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * `SeedResult` type.
 */

export type SeedResult = { wallets: number; entries: number };

/**
 * Export `useSeedCryptoGest` — (re)seed the Crypto Gest manual wallets for the
 * logged-in user (admin/dev only).
 */

export function useSeedCryptoGest() {
  const client = useRequestProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<SeedResult> =>
      client.post(resolveAppUrl('adminDevelopmentCryptoGestSeed')).then(({ data }: { data: any }) => data?.data),
    onSuccess: () => {
      queryClient.invalidateQueries(['cryptoGest']);
    }
  });
}

/**
 * Export `useRollbackCryptoGest` — remove the seeded Crypto Gest wallets for the
 * logged-in user (admin/dev only).
 */

export function useRollbackCryptoGest() {
  const client = useRequestProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () =>
      client.post(resolveAppUrl('adminDevelopmentCryptoGestRollback')).then(({ data }: { data: any }) => data),
    onSuccess: () => {
      queryClient.invalidateQueries(['cryptoGest']);
    }
  });
}
